<template>
  <Flash v-if="showFlash" alert="success">Your practice preferences have been saved</Flash>
  <div v-if="!editPage">
    <practice-prefences-read-only @edit-page="switchPage"></practice-prefences-read-only>
  </div>
  <div v-if="editPage">
    <practice-prefences @show-flash="handleShowFlash" @edit-page="switchPage"></practice-prefences>
  </div>
</template>
<script>
import PracticePrefencesReadOnly from "@/components/PracticePrefencesReadOnly.vue";
import PracticePrefences from "@/components/PracticePrefences.vue";
import Flash from "@/components/Flash.vue";


export default {
  components: {
    PracticePrefences,
    PracticePrefencesReadOnly,
    Flash
  },
  data(){
    return {
      editPage: false,
      page: this.$router.currentRoute._value.query.preferences ?? 'practice_details',
      tabActive: [true, false]
    }
  }, methods: {
    switchPage(){
      this.showFlash = false;
      this.editPage = !this.editPage;
    },
    handleShowFlash(){
      this.showFlash = true;
    },
  }
}
</script>